/* Gold & Richie — faceted filtering
   Enhances a working GET form. Without JS, Apply submits and the page reloads. */

(function () {
  'use strict';

  var form = document.querySelector('[data-gr-facet-form]');
  if (!form) return;

  var GR = window.GR;
  var collection = document.querySelector('[data-gr-collection]');
  if (!collection) return;

  var inFlight = null;

  function serialise() {
    var data = new FormData(form);
    var params = new URLSearchParams();

    data.forEach(function (value, key) {
      if (value === '' || value == null) return;
      params.append(key, value);
    });

    return params.toString();
  }

  function setBusy(busy) {
    collection.dataset.loading = busy ? 'true' : 'false';
    var apply = form.querySelector('[data-gr-facet-apply]');
    if (apply) {
      if (busy) { apply.dataset.loading = 'true'; } else { delete apply.dataset.loading; }
    }
  }

  function render(html, url) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');

    // Swap the grid, the count, the active pills, and the drawer's own counts.
    [
      '.gr-product-grid',
      '.gr-collection__count',
      '.gr-active-filters',
      '.gr-pagination',
      '.gr-empty'
    ].forEach(function (selector) {
      var next = parsed.querySelector(selector);
      var current = document.querySelector(selector);

      if (next && current) {
        current.replaceWith(next);
      } else if (next && !current) {
        var grid = document.querySelector('.gr-product-grid') || document.querySelector('.gr-empty');
        if (grid && grid.parentNode) grid.parentNode.appendChild(next);
      } else if (!next && current) {
        current.remove();
      }
    });

    // Refresh the facet counts without losing which panels are open.
    var nextForm = parsed.querySelector('[data-gr-facet-form]');
    if (nextForm) {
      var openPanels = {};
      form.querySelectorAll('[data-gr-accordion-toggle]').forEach(function (toggle) {
        openPanels[toggle.getAttribute('aria-controls')] = toggle.getAttribute('aria-expanded');
      });

      var body = form.querySelector('.gr-drawer__body');
      var nextBody = nextForm.querySelector('.gr-drawer__body');
      if (body && nextBody) {
        body.innerHTML = nextBody.innerHTML;

        Object.keys(openPanels).forEach(function (id) {
          var toggle = form.querySelector('[aria-controls="' + id + '"]');
          var panel = document.getElementById(id);
          if (!toggle || !panel) return;

          var isOpen = openPanels[id] === 'true';
          toggle.setAttribute('aria-expanded', String(isOpen));
          panel.hidden = !isOpen;
        });
      }
    }

    // Update the count on the filter button.
    var nextBtnCount = parsed.querySelector('.gr-filter-btn__count');
    var btn = document.querySelector('.gr-filter-btn');
    var currentBtnCount = document.querySelector('.gr-filter-btn__count');
    if (currentBtnCount) currentBtnCount.remove();
    if (nextBtnCount && btn) btn.appendChild(nextBtnCount);

    if (GR && GR.observeReveals) GR.observeReveals(collection);
    if (url) window.history.replaceState({}, '', url);
  }

  function apply(pushFocus) {
    var query = serialise();
    var url = form.getAttribute('action') + (query ? '?' + query : '');

    if (inFlight) inFlight.abort();
    inFlight = new AbortController();

    setBusy(true);

    fetch(url, { signal: inFlight.signal })
      .then(function (response) {
        if (!response.ok) throw new Error('Filter request failed');
        return response.text();
      })
      .then(function (html) {
        render(html, url);
        setBusy(false);

        var count = document.querySelector('.gr-collection__count');
        if (count && GR) GR.announce(count.textContent.trim());

        if (pushFocus) {
          var grid = document.getElementById('gr-product-grid');
          if (grid) grid.setAttribute('tabindex', '-1');
          if (grid) grid.focus({ preventScroll: true });
        }
      })
      .catch(function (error) {
        if (error.name === 'AbortError') return;
        setBusy(false);
        // If the live update fails, fall back to a normal navigation.
        window.location.href = url;
      });
  }

  // Live-update on every change; Apply then just closes the drawer.
  var debounce;
  form.addEventListener('change', function () {
    window.clearTimeout(debounce);
    debounce = window.setTimeout(function () { apply(false); }, 260);
  });

  form.addEventListener('input', function (event) {
    if (event.target.type !== 'number') return;
    window.clearTimeout(debounce);
    debounce = window.setTimeout(function () { apply(false); }, 600);
  });

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    apply(true);
    if (GR) GR.closeDrawer('gr-facet-drawer');
  });

  // Removing a pill or paginating stays on the page.
  document.addEventListener('click', function (event) {
    var link = event.target.closest('.gr-active-filter, .gr-pagination a');
    if (!link) return;

    event.preventDefault();
    var url = link.getAttribute('href');

    setBusy(true);
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        render(html, url);
        setBusy(false);
        window.scrollTo({ top: collection.offsetTop - 100, behavior: 'smooth' });
      })
      .catch(function () { window.location.href = url; });
  });
})();
